import locationTasksTemplate from './locationTasks.html';
import './locationTasks.scss';

export default angular
  .module('main.locations.edit.components.tasks', [])

  /**
   * Location tasks list
   */
  .directive('editLocationTasks', () => {
    return {
      restrict: 'E',
      template: locationTasksTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   $timeout,
                   EditLocationDataProvider,
                   utils) => {
        $scope.dataProvider = EditLocationDataProvider.instance;

        angular.extend($scope, {
          onTaskClick: onTaskClick,
          onViewTaskButtonClick: onViewTaskButtonClick,
          onEditTaskButtonClick: onEditTaskButtonClick,
          onCompleteTaskButtonClick: onCompleteTaskButtonClick,
          getTaskColorStyle: getTaskColorStyle
        });

        init();

        function init() {
          $scope.loading = true;
          $q.all([
            $scope.dataProvider.locationTasksResource.init(),
            $scope.dataProvider.isLocationTasksEditableResource.init(),
          ])
            .then(() => {
              $scope.loading = false;
            }, (err) => {
              $scope.loading = false;
              // utils.handleApiError(err);
            });

          $scope.$on('$destroy', () => {
            $('#delete-task-dialog')?.remove();
          });
        }

        function onTaskClick(task, $event) {
          $event?.stopPropagation();
          gotoViewOrEditTask(task);
        }

        function onViewTaskButtonClick(task) {
          gotoViewOrEditTask(task);
        }

        function onEditTaskButtonClick(task) {
          gotoViewOrEditTask(task);
        }

        function onCompleteTaskButtonClick(task) {
          removeTask(task);
        }

        function gotoViewOrEditTask(task) {
          $scope.dataProvider.taskToEdit = angular.copy(task);
          $scope.dataProvider.activeTab = 'editTask';
        }

        function removeTask(task) {
          if ($scope.loading || !task || $scope.dataProvider.isLocationTasksEditableResource.value !== true) {
            return;
          }

          $('#delete-task-dialog').modal({
            closable: true,
            detachable: true,
            onApprove: function() {
              $('#delete-task-dialog').modal('hide');
              $scope.loading = true;
              $scope.dataProvider.removeLocationTask(task)
                .then(() => {
                  $scope.loading = false;
                }, (err) => {
                  $scope.loading = false;
                  utils.handleApiError(err);
                });
            }
          }).modal('show');
        }

        function getTaskColorStyle(task) {
          if (!task) {
            return 'grey-mark';
          } else if (task.priority === 1) {
            return 'blue-mark';
          } else if (task.priority === 2) {
            return 'orange-mark';
          } else if (task.priority === 3) {
            return 'red-mark';
          }
          return 'grey-mark';
        }

      }
    };
  })
  .name;
